export const tabsData = [
  "description",
  "contacts",
  "important dates",
  "company",
  "activities",
  "comments"
];
